export const SET_USERNAME = "SET_USERNAME";
export const SET_CUSTOMER_DATA = "SET_CUSTOMER_DATA";
export const SET_SNACK = "SET_SNACK";
export const SET_META_DATA = "SET_META_DATA";
export const SET_SUPER_USER = "SET_SUPER_USER";
export const SET_ADMIN_USER_DATA = "SET_ADMIN_USER";
export const SET_GENERAL = "SET_GENERAL";
export const SET_SW_DATA = "SET_SW_DATA";
export const SET_CONTRACTOR_DATA = "SET_CONTRACTOR_DATA";
